import { useState, useEffect } from "react";

const useSearch = ({ getData }) => {
  const [searchText, setSearchText] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [searchLoading, setSearchLoading] = useState(true);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (searchText) {
        setSearchLoading(true);
        getData({ searchText }).then((res) => {
          setSearchLoading(false);
          setSearchResult(
            res.hits.map((item) => ({ ...item, id: item.objectID })),
          );
        });
      } else {
        setSearchLoading(false);
        setSearchResult([]);
      }
    }, 1000);

    return () => {
      clearTimeout(handler); // Clean up on unmount or value change
    };
  }, [searchText]);

  return {
    setSearchText,
    searchText,
    searchResult,
    searchLoading,
  };
};

export default useSearch;
